<div class="container-fluid">
  <br>
  <div class="cat">
    <select [(ngModel)]="selectedCategory" (change)='getNewBooks(selectedCategory); getTopBooks(selectedCategory)'
      class="category_list">
      <option *ngFor="let category of categories" [value]="category.category">{{category.categoryName}}</option>
    </select>
  </div>
  <br>
  <h3 class="header_books">Most recent books</h3>
  <div class="row row-cols-2">
    <div class="col-sm-12 col-md-6 col-12 column newest-books">
      <div id="carousel0" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#carousel0" *ngFor="let book of recentBooks.items;let index = index"
            [attr.data-slide-to]="index"></li>
        </ol>
        <div class="col-sm-12 col-md-6 col-12 carousel-inner">
          <div class="carousel-item" *ngFor="let book of recentBooks.items;let index = index;let isFirst = first"
            [ngClass]="{active:isFirst}">
            <img
              [src]="book.volumeInfo?.imageLinks != undefined ? book.volumeInfo!.imageLinks?.thumbnail : 'assets/img/wormnotfound.jpg'"
              class="rounded d-block w-100" [alt]="book.volumeInfo?.title">
              <!--<a href="http://www.freepik.com" target="_blank">Designed by pch.vector / freepik</a>-->
          </div>
        </div>
        <a class="carousel-control-prev" href="#carousel0" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carousel0" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
    <div class="column">
      <ul id="newest_buttons" *ngFor="let book of recentBooks.items" class="list-group">
        <li class="list-group"><a routerLink="/book/{{book.id}}" class="button" [title]="book.volumeInfo?.title">
            <p>{{ book.volumeInfo?.title }}</p>
          </a></li>
      </ul>
    </div>
  </div>
  <h3 class="header_books">Most relevant books</h3>
  <div class="row row-cols-2">
    <div class="col-sm-12 col-md-6 col-12 column relevant-books">
      <div id="carousel1" class="carousel slide" data-ride="carousel">
        <ol class="carousel-indicators">
          <li data-target="#carousel1" *ngFor="let book of relevantBooks.items;let index = index"
            [attr.data-slide-to]="index"></li>
        </ol>
        <div class="col-sm-12 col-md-6 col-12 carousel-inner">
          <div class="carousel-item" *ngFor="let book of relevantBooks.items;let index = index;let isFirst = first"
            [ngClass]="{active:isFirst}">
            <img
              [src]="book.volumeInfo?.imageLinks != undefined ? book.volumeInfo!.imageLinks?.thumbnail : 'assets/img/wormnotfound.jpg'"
              class="rounded d-block w-100" [alt]="book.volumeInfo?.title">
              <!--<a href="http://www.freepik.com" target="_blank">Designed by pch.vector / freepik</a>-->
          </div>
        </div>
        <a class="carousel-control-prev" href="#carousel1" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carousel1" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>
      </div>
    </div>
    <div class="column">
      <ul id="newest_buttons" *ngFor="let book of relevantBooks.items" class="list-group">
        <li class="list-group"><a routerLink="/book/{{book.id}}" class="button" [title]="book.volumeInfo?.title">
            <p>{{ book.volumeInfo?.title }}</p>
          </a></li>
      </ul>
    </div>
  </div>
</div>
